var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStatusViewNone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1020_13134)",
    stroke: "#323657",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.465 10.465A5.874 5.874 0 0 1 7 11.667C2.917 11.667.583 7 .583 7a10.763 10.763 0 0 1 2.952-3.465m2.24-1.062A5.32 5.32 0 0 1 7 2.333C11.083 2.333 13.417 7 13.417 7a10.793 10.793 0 0 1-1.26 1.86m-3.92-.623a1.75 1.75 0 1 1-2.474-2.474M.583.583l12.834 12.834"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1020_13134"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h14v14H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatusViewNone);
export default __webpack_public_path__ + "static/media/status-view-none.40a45a05086f559ae5c623ba3c74dd03.svg";
export { ForwardRef as ReactComponent };